import React from "react";
import { CheckCircle } from "lucide-react"; // modernes Icon (z. B. von lucide)
import { SectionHeader } from "./SectionHeader";
export const Rules = ({ data }) => {
  if (!data) return <div id="rules">loading...</div>;

  return (
    <div id="rules" className="py-5">
      <SectionHeader />
       <div className="container">
        {/* Überschrift */}
        <div className="section-title text-center mb-4">
          <h1 className="rules-title">{data.titleCV1}</h1>
          <h1 className="rules-title">{data.titleCV2}</h1>
          <h3 className="rules-item">{data.titleCV3}</h3>
        </div>

        {/* Grid mit Lebensläufen */}
      <div className="cv-grid">
        {data.cvs.map((cv) => (
          <section key={cv.id} id={cv.id} className="cv-card cv-section">
            <h3 className="cv-name">{cv.name}</h3>
            <p className="cv-description">{cv.description}</p>
          </section>
        ))}
      </div>
      
      <div className="section-title text-center mb-4">
      <h3 className="rules-item"> Die Düsseldorfer Soroptimistinnen
                            wünschen viel Glück im Advent 2026!</h3>
    </div>
</div>
     

      <SectionHeader />
      <div className="container">
        {/* Überschrift */}
        <div className="section-title text-center mb-4">
          <h2 className="rules-title">{data.title}</h2>
        </div>

        {/* Liste */}
        <ul className="rules-list">
          {data.items.map((item, i) => (
            <li key={i} className="rules-item">
              <CheckCircle className="rules-icon" size={20} />
              <span dangerouslySetInnerHTML={{ __html: item }} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};